import axios from './axios'
import { api } from './api'

// 用户信息
export const getMyself = () => {
  return axios({
    url: api.user.MYSELF(),
    method: 'GET'
  })
}
// 腾讯验证码
export const tencentCaptcha = (data) => {
  return axios({
    url: api.user.CAPTCHA_TENCENT(),
    method: 'POST',
    data: data
  })
}

// 获取短信验证码
export const getSmsCaptha = (data) => {
  return axios({
    url: api.user.GET_SMS_CAPTCHA(),
    method: 'GET',
    params: data
  })
}

// 验证短信验证码
export const checkSmsCaptha = (data) => {
  return axios({
    url: api.user.CHECK_SMS_CAPTCHA(),
    method: 'POST',
    data: data
  })
}

// 手机号画像图表
export const phoneUsage = (params) => {
  return axios({
    url: api.yongan.PHONE_USAGE(),
    method: 'GET',
    params: params
  })
}
// 获取产品列表
export const getProductList = (params) => {
  return axios({
    url: api.yongan.PRODUCT_LIST(),
    method: 'GET',
    params: params
  })
}

// 获取产品秘钥
export const getKey = async () => {
  return axios({
    url: api.yongan.GET_KEY(),
    method: 'GET'
  })
}

// 获取访问ip白名单列表
export const getIpList = () => {
  return axios({
    url: api.user.GET_IP_LIST(),
    method: 'GET'
  })
}

// 添加ip
export const addIpFun = (data) => {
  return axios({
    url: api.user.DEL_IP(),
    method: 'POST',
    data: data
  })
}

// 删除ip
export const delIpFun = (data) => {
  return axios({
    url: api.user.DEL_IP(),
    method: 'DELETE',
    data: data
  })
}

// 获取绑定微信
export const getWXUser = (data) => {
  return axios({
    url: api.user.WX_USER_LIST(),
    method: 'GET',
    params: data
  })
}

// 获取公众号二维码
export const getBindImg = (uuid) => {
  return axios({
    url: api.user.BIND_WECHAT(),
    method: 'GET'
  })
}

// 解绑微信
export const unBind = (uuid) => {
  return axios({
    url: api.user.UNBIND_WECHAT(uuid),
    method: 'POST'
  })
}

// 修改姓名
export const updateSelf = (data) => {
  return axios({
    url: api.user.MYSELF(),
    method: 'PATCH',
    data: data
  })
}

// 修改邮箱
export const emailChange = (data) => {
  return axios({
    url: api.user.EMAIL_CHANGE(),
    method: 'POST',
    data: data
  })
}

// 获取告警邮箱配置
export const getAlertEmailConfig = () => {
  return axios({
    url: api.user.ALERT_EMAIL(),
    method: 'GET'
  })
}

// 批量添加告警邮箱
export const addAlertEmails = (data) => {
  return axios({
    url: api.user.ALERT_EMAIL(),
    method: 'POST',
    data
  })
}

// 删除告警邮箱
export const deleteAlertEmail = (data) => {
  return axios({
    url: api.user.ALERT_EMAIL(),
    method: 'DELETE',
    data
  })
}

// 修改手机号
export const phoneChange = (data) => {
  return axios({
    url: api.user.PHONE_CHANGE(),
    method: 'POST',
    data: data
  })
}

// 获取反欺诈决策引擎图表数据
export const getFingerPrintAggregate = (params) => {
  console.log(params)
  return axios({
    url: api.fingerprint.FINERPRINT_AGGREGATE(),
    method: 'GET',
    params: params
  })
}
export const getFingerPrintDeviceTag = (params) => {
  return axios({
    url: api.fingerprint.FINERPRINT_TAG(),
    method: 'GET',
    params: params
  })
}

export const getFingerPrintList = async (params) => {
  return await axios({
    url: api.fingerprint.FINERPRINT_List(),
    method: 'GET',
    params: params
  })
}

// 获取用户登录日志
export const getUserLog = (params) => {
  return axios({
    url: api.user.GETUSERLOG(),
    method: 'GET',
    params
  })
}

// 手机号画像反馈获取全部提交列表
export const getPhoneAllEvent = (params) => {
  return axios({
    url: api.user.GETPHONEALLEVENTLIST(),
    method: 'GET',
    params
  })
}

// 手机号画像反馈上传手机号
export const phoneUploadByInput = (data) => {
  return axios({
    url: api.user.PHONEUPLOADPARM(),
    method: 'POST',
    data: data
  })
}

// 手机画像反馈获取事件手机号详情
export const getPhoneEventDetail = (id, params) => {
  return axios({
    url: api.user.GETPHONEFEEDBACKDETAIL(id),
    method: 'GET',
    params
  })
}

// 手机号画像获取echart数据，获取当天
export const getPhoneEchartDataForHourly = (params) => {
  return axios({
    url: api.user.GET_PHONE_CHART_DATA_HOURLY(),
    method: 'GET',
    params
  })
}

// 手机号画像获取echart数据，自定义时间
export const getPhoneEchartDataForDaily = (params) => {
  return axios({
    url: api.user.GET_PHONE_CHART_DATA_DAILY(),
    method: 'GET',
    params
  })
}

// ip业务安全版在线api获取echart数据，获取当天
export const getIpEchartDataForHourly = (params) => {
  return axios({
    url: api.user.GET_IP_CHART_DATA_HOURLY(),
    method: 'GET',
    params
  })
}

// ip业务安全版在线api获取echart数据，自定义时间
export const getIpEchartDataForDaily = (params) => {
  return axios({
    url: api.user.GET_IP_CHART_DATA_DAILY(),
    method: 'GET',
    params
  })
}

// 手机号画像离线版本获取更新包数据
export const getPhoneUpdatePackageData = (params) => {
  return axios({
    url: api.user.GET_PHONE_OFFLINE_UPDATE_PACKAGE(),
    method: 'GET',
    params
  })
}

// 境外手机号画像私有化版本获取更新包数据
export const getPhoneOverseasUpdatePackageData = (params) => {
  return axios({
    url: api.user.GET_PHONE_OVERSEAS_OFFLINE_UPDATE_PACKAGE(),
    method: 'GET',
    params
  })
}

// 手机号攻击情报离线版本获取更新包日志
export const getGroupReceiveCodeOfflineLog = (params) => {
  return axios({
    url: api.user.GET_GROUP_RECEIVE_CODE_OFFLINE_LOG(),
    method: 'GET',
    params
  })
}

// 金融反欺诈画像离线产品获取更新包日志
export const getFinancialAntiFraudOfflineLog = (params) => {
  return axios({
    url: api.user.GET_FINANCIAL_ANTI_FRAUD_OFFLINE_LOG(),
    method: 'GET',
    params
  })
}

// ip画像离线版本获取更新包数据
export const getIpUpdatePackageData = (params) => {
  return axios({
    url: api.user.GET_IP_OFFLINE_UPDATE_PACKAGE(),
    method: 'GET',
    params
  })
}

// 获取官网研究报告前三条
export const getReport = () => {
  return axios({
    url: api.official.PDF_READ(),
    method: 'GET'
  })
}

// 验证邮箱类型
export const getEmailType = (params) => {
  return axios({
    url: api.public.GET_EMAIL_TYPE(),
    method: 'GET',
    params
  })
}

// 邮箱反馈
export const postFeedBack = (data) => {
  return axios({
    url: api.public.USER_FEEDBACK(),
    method: 'POST',
    data
  })
}
